import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Wishlist } from '../../../domain/models/wishlist.models';
import { getWishlist, getWishlistStatus } from '../../state/wishlist.selectors';

/**
 * Facade para peticiones a la store interna
 */

@Injectable()
export class WishlistQueriesFacade {
    constructor(
        private readonly store: Store,
    ) { }

    // Recupera la wishlist
    public getWishlist$(): Observable<Wishlist> {
        return this.store.select(getWishlist);
    }

    // Recupera el estado de la wishlist
    public getWishlistStatus$(): Observable<any> {
        return this.store.select(getWishlistStatus);
    }
}
